__turbopack_context__.v({
  "wrapper": "RelatedProductSingleItem-module-scss-module__u85kDG__wrapper",
});
